export default [{
        name: '首页',
        path: '/',
        icon: 'ios-home-outline',
        authority: 'Manage Edit'
    }, {
        name: '联络平台首页',
        path: '',
        icon: 'ios-world-outline',
        alias: 'llpt',
        stydioType: '18',
        authority: 'Manage Edit'
    }, {
        name: '创发平台首页',
        path: '',
        icon: 'ios-world-outline',
        alias: 'cfpt',
        stydioType: '17',
        authority: 'Manage Edit'
    },
    {
        name: '党员培训信息平台',
        path: '',
        icon: 'ios-world-outline',
        alias: 'dypxpt',
        stydioType: '20',
        authority: 'Manage Edit'
    },
    {
        name: '发表',
        path: '/publish',
        icon: 'ios-compose-outline',
        authority: 'Manage Edit'
    }, {
        name: '管理',
        icon: 'ios-paper-outline',
        authority: 'Manage Edit',
        children: [
            // {
            //     name: '公告管理',
            //     path: '/manage/announcement',

            //     authority: 'Manage'
            // },
            {
                name: '内容管理',
                path: '/manage/content',
                authority: 'Manage Edit'
            },
            {
                name: '幻灯管理',
                path: '/manage/slide',
                authority: 'Manage Edit'
            },
            {
                name: '评论管理',
                path: '/manage/comment',
                authority: 'Manage Edit'
            },
            // {
            //     name: '育人号管理',
            //     path: '/manage/studio',
            //     match: ['manageStudioSingle'], // 如匹配路由name也可激活<Menu:activeName>
            //     authority: 'Manage'
            // },
            // {
            //     name: '广告管理',
            //     path: '/manage/ad',
            //     authority: 'Manage'
            // },
            // {
            //     name: '育人号审核',
            //     path: '/manage/fusionaudit',
            //     authority: 'Manage Audit'
            // },
            // {
            //     name: '内容审核',
            //     path: '/manage/contentaudit',
            //     authority: 'Manage'
            // },
            {
                name: '素材管理',
                path: '/manage/material',
                match: ['SourceMaterialEnter'],
                authority: 'Manage Edit'
            },
            {
                name: '栏目管理',
                path: '/manage/tagword',
                authority: 'Manage'
            },
            {
                name: '项目成员管理',
                path: '/manage/member',
                stydioType: '17',
                authority: 'Manage Edit'
            },
            // {
            //     name: '水印管理',
            //     path: '/manage/watermark',
            //     authority: 'Manage'
            // },
            // {
            //     name: '直播管理',
            //     path: '/manage/live',
            //     match: ['SourceLiveEnter'],
            //     authority: 'Manage Edit'
            // },
            // {
            //     name: '账号管理',
            //     path: '/manage/account',
            //     match: ['manageAccountSingle'], // 如匹配路由name也可激活<Menu:activeName>
            //     authority: 'Manage'
            // },
        ]
    },
    {
        name: '数据统计',
        icon: 'stats-bars',
        authority: 'Manage Edit',
        children: [{
                name: '内容统计',
                path: '/datastatistics/content',
                authority: 'Manage Edit',
                match: 'datasummary,exponential'
            },
            // {
            //     name: '粉丝分析',
            //     path: '/datastatistics/fans',
            //     authority: 'Manage Edit',
            //     match: 'fansummary,attribute,search,fanslist'
            // },
            {
                name: '育人号排序',
                path: '/datastatistics/sort',
                authority: 'Manage Edit'
            }
        ]
    },
    // {
    //     name: '广告',
    //     path: '/ad',
    //     icon: 'social-youtube',
    //     authority: 'Manage Edit'
    // },
    // {
    //     name: '渠道',
    //     icon: 'social-dropbox-outline',
    //     authority: 'Manage Edit',
    //     children: [{
    //             name: '内容接入',
    //             path: '/channel/minput',
    //             authority: 'Manage',
    //             match: 'miwechatlist,miwebsitelist'
    //         },
    //         {
    //             name: '内容输出',
    //             path: '/channel/moutput',
    //             authority: 'Manage',
    //             match: 'mowechatlist,momicrobloglist'
    //         },
    //         {
    //             name: '内容接入',
    //             path: '/channel/einput',
    //             authority: 'Manage Edit',
    //             match: 'eiwechatadd,eiwebsiteadd'
    //         },
    //         {
    //             name: '内容输出',
    //             path: '/channel/eoutput',
    //             authority: 'Manage Edit',
    //             match: 'eowechatadd,eomicroblogadd'
    //         }
    //     ]
    // },
    {
        name: '设置',
        icon: 'ios-gear-outline',
        authority: 'Manage Edit',
        children: [{
                name: '账号信息',
                path: '/settings/account',
                authority: 'Manage Edit'
            },
            {
                name: '简介信息',
                path: '/settings/basic',
                authority: 'Manage Edit'
            }
        ]
    },
    {
        name: '系统管理',
        icon: 'ios-settings',
        authority: 'Manage Edit',
        children: [{
                name: '工作简报',
                path: '/system/work',
                authority: 'Manage Edit'
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./src/config/studio.js